import $, { isEmptyObject } from 'jquery';

import React from "react";
import LoginService from '../services/login.js';
import Utility from '../utilities/utility.js';



class Login extends React.Component {

    constructor() {
        super();
        this.state = {
            token: null
        };
    }


    login() {

        $('#login-progress').html('Login In Progress.........');

        let username = $('#username').val();
        let password = $('#password').val();

        if (Utility.isEmpty(username) || Utility.isEmpty(password)) {

            $('#login-progress').html(
                '<div class="alert alert-warning">Des parametres requis sont manquants</div>'
            );



            return;
        }


     

        try {
 
             let username = $('#username').val();
             let password = $('#password').val();
 
             if(Utility.isEmpty(username) || Utility.isEmpty(password) ){
 
                 $('#login-progress').html(
                     '<div class="alert alert-warning">Des parametres requis sont manquants</div>'
                 );
 
                 return;
             }
             
             let response = LoginService.loginUser({ username, password });
 
             
             response.then(data => {
 
                 if ((data == undefined)) {
 
 
 
                     window.location.href = '/login';
                 }
 
                 if (data.token) {
 
                     localStorage.setItem('token', data.token);
                     localStorage.setItem('sessionData', JSON.stringify(data));
                     
                    
                     window.location.href = '/dashboard';
                 }
 
 
 
             })
 
         } catch (error) {
             console.log(error);

             window.location.href = '/login';
         }



    }

    render() {
        return (

            <div className="login-wrapper">
                <p id='login-progress' className='text-center text-info'></p>
                <div className="form-group row">
                    <input type="text" className="form-control" id="username" placeholder="Username" />

                </div>

                <div className="form-group row">

                    <input type="password" className="form-control" id="password" placeholder="Password" />
                </div>

                <div className="form-group">
                    <button className="btn btn-primary" onClick={this.login}>Login</button>
                </div>
            </div>

        );
    }
}

export default Login;